import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class SubjectService {

  private baseUrl = environment.apiUrl + '/v1/subjects';

  constructor(private http: HttpClient) {}

  getSubjects() {
    return this.http.get(`${this.baseUrl}`);
  }

  addSubject(subjectData: any) {
    return this.http.post(`${this.baseUrl}`, subjectData);
  }

  updateSubject(id: number, subjectData: any) {
    return this.http.put(`${this.baseUrl}/${id}`, subjectData);
  }

  changeStatus(id: number, status: string) {
    return this.http.patch(`${this.baseUrl}/${id}/status?status=${status}`, {});
  }
}